import { useState } from 'react';
import useMountEffect from 'hooks/useMountEffect';
import { Breakpoints, Breakpoint } from '@landr/maestro-legacy';

export type CurrentBreakpoint = Breakpoint | 'default' | 'unknown';

const getCalculateBreakpoint = (): CurrentBreakpoint => {
    let currentBreakpoint: CurrentBreakpoint = 'unknown';

    const windowWidth = window.innerWidth;

    if (windowWidth <= Breakpoints.xs) {
        currentBreakpoint = 'xs';
    } else if (windowWidth <= Breakpoints.sm) {
        currentBreakpoint = 'sm';
    } else if (windowWidth <= Breakpoints.ms) {
        currentBreakpoint = 'ms';
    } else if (windowWidth <= Breakpoints.md) {
        currentBreakpoint = 'md';
    } else if (windowWidth <= Breakpoints.ml) {
        currentBreakpoint = 'ml';
    } else if (windowWidth <= Breakpoints.lg) {
        currentBreakpoint = 'lg';
    } else if (windowWidth <= Breakpoints.xl) {
        currentBreakpoint = 'xl';
    } else if (windowWidth <= Breakpoints.xxl) {
        currentBreakpoint = 'xxl';
    } else {
        currentBreakpoint = 'default';
    }

    return currentBreakpoint;
};

const useGetCurrentBreakpoint = (): CurrentBreakpoint => {
    const [currentBreakpoint, setCurrentBreakpoint] =
        useState<CurrentBreakpoint>(getCalculateBreakpoint());

    const calculateBreakpoint = () => {
        const newBreakpoint = getCalculateBreakpoint();

        setCurrentBreakpoint(newBreakpoint);
    };

    useMountEffect(
        () => {
            window.addEventListener('resize', calculateBreakpoint);
        },
        () => window.removeEventListener('resize', calculateBreakpoint),
    );

    return currentBreakpoint;
};

export default useGetCurrentBreakpoint;
